
import SpecialReportsWidget from 'features/Weather/features/SpecialReports/index.web.widget';
import CombinedChartsWidget from 'features/Weather/features/Forecast/widgets/CombinedChartsWidget/CombinedChartsWidget';
import DeviceGroupWidget from 'components/Widgets/DeviceGroupWidget';
import ConnectedDevicesWidget from 'features/Integrations/features/ConnectedDevices/index.web.widget';
import USGSMapWidget from 'features/Integrations/features/ConnectedDevices/widgets/USGSMapWidget';
import ExacqVisionVMSWidget from 'features/VMS/index.web.widget';
import WeatherMapsWidget from 'features/Weather/features/WeatherMaps/index.web.widget.jsx';
import ForecastWidget from 'features/Weather/features/Forecast/index.web.widget';
import MarineForecastWidget from 'features/Weather/features/MarineForecast/index.web.widget';
import WeatherAlertsWidget from 'features/Weather/features/WeatherAlerts/index.web.widget';
import Connections from 'pages/System/Connections';
import Alerts from 'pages/Weather/Alerts';
import CreateAlert from 'pages/Weather/CreateAlert';
import { createWidgetRendererHelpers } from './widgetHelpers';

export const getWidgetRenderers = (
  widgetRefresh,
  setWidgetRefresh,
  sidebarOpen
) => {
  
  // Helper factory binds refresh/sidebar props once and returns widget renderers.
  const {
    renderWidget,
    renderMapWidget,
    renderConnectedDevices,
    renderMapConnectionsWidget,
  } = createWidgetRendererHelpers({ widgetRefresh, setWidgetRefresh, sidebarOpen });

  // Map widget id -> render function; widgetMeta references the same ids.
  return {
    1: renderMapWidget(WeatherMapsWidget, { widgetType: 'severeWeatherAlerts' }),
    2: renderWidget(ForecastWidget, {widgetType: 'hourlyForecast'}),
    3: renderMapWidget(WeatherMapsWidget, { widgetType: 'currentConditions' }),
    4: renderWidget(ForecastWidget, {widgetType: 'detailedForecast'}, { layoutPreset: 'forecastFit', clipOverflow: true }),
    5: renderWidget(ForecastWidget, {widgetType: 'day15Forecast'}, { layoutPreset: 'forecastFit', clipOverflow: true }),
    6: renderWidget(ForecastWidget, {widgetType: 'airQualityObservations'}),
    7: renderWidget(ForecastWidget, {widgetType: 'airQualityForecast'}),
    8: renderWidget(WeatherAlertsWidget, { widgetType: 'nwsAlerts' }),
    9: renderWidget(WeatherAlertsWidget, { widgetType: 'myForecastAdvisories' }),
    10: renderWidget(
      MarineForecastWidget,
      { widgetType: 'waveAndWind' },
      { layoutPreset: 'forecastFit', clipOverflow: true },
    ),
    11: renderWidget(
      MarineForecastWidget,
      { widgetType: 'surfAlerts' },
      { layoutPreset: 'forecastFit', clipOverflow: true },
    ),
    12: renderWidget(
      MarineForecastWidget,
      { widgetType: 'buoyConditions' },
      { layoutPreset: 'forecastFit', clipOverflow: true },
    ),
    13: renderWidget(
      MarineForecastWidget,
      { widgetType: 'tideTable' },
      { layoutPreset: 'forecastFit', clipOverflow: true },
    ),
    14: renderMapWidget(WeatherMapsWidget, { widgetType: 'earthquakes' }),
    15: renderMapWidget(WeatherMapsWidget, { widgetType: 'hurricanesTropicalStorms' }),
    16: renderWidget(CombinedChartsWidget, { defaultTab: 0 }),
    17: renderWidget(CombinedChartsWidget, { defaultTab: 1 }),
    18: renderWidget(CombinedChartsWidget, { defaultTab: 2 }),
    19: renderWidget(CombinedChartsWidget, { defaultTab: 3 }),
    20: renderWidget(CombinedChartsWidget, { defaultTab: 4 }),
    21: renderWidget(CombinedChartsWidget, { defaultTab: 5 }),
    22: renderWidget(CombinedChartsWidget, { defaultTab: 6 }),
    23: renderWidget(CombinedChartsWidget, { defaultTab: 7 }),
    24: renderWidget(CombinedChartsWidget, { defaultTab: 8 }),
    25: renderWidget(CombinedChartsWidget, { defaultTab: 9 }),
    26: renderWidget(CombinedChartsWidget, { defaultTab: 10 }),
    27: renderWidget(
      SpecialReportsWidget,
      { widgetType: 'fireDanger' },
      { layoutPreset: 'forecastFit', clipOverflow: true },
    ),
    28: renderWidget(
      SpecialReportsWidget,
      { widgetType: 'airportDelays' },
      { layoutPreset: 'forecastFit', clipOverflow: true },
    ),
    29: renderWidget(
      SpecialReportsWidget,
      { widgetType: 'skiReports' },
      { layoutPreset: 'forecastFit', clipOverflow: true },
    ),
    30: renderConnectedDevices("graph", ConnectedDevicesWidget),
    31: renderConnectedDevices('stageFloodMap', ConnectedDevicesWidget, { mapWidget: true }),
    32: renderMapWidget(WeatherMapsWidget, { widgetType: 'dopplerRadar' }),

    // Custom alert filter stays local to this widget renderer.
    33: (w, h, preview) => (
      <Alerts
        widgetRefresh={widgetRefresh}
        setWidgetRefresh={setWidgetRefresh}
        sidebarOpen={sidebarOpen}
        dimensions={[w, h]}
        preview={preview}
        filterAlerts={(list) =>
          list.filter((item) => item.provider === 'Custom Weather')
        }
      />
    ),

    34: renderMapConnectionsWidget('technologyBridgeFlashingLights', Connections),
    35: renderMapConnectionsWidget('manualRoadClosure', Connections),
    36: renderMapConnectionsWidget('technologyBridgeSiren', Connections),
    37: renderConnectedDevices("list", ConnectedDevicesWidget),

    38: (w, h) => <DeviceGroupWidget dimensions={[w, h]} />,

    39: renderMapWidget(USGSMapWidget),

    101: renderWidget(Alerts),

    102: (w, h, preview) => (
      <CreateAlert
        widget
        dimensions={[w, h]}
      />
    ),
    103: renderWidget(ExacqVisionVMSWidget),

    104: renderMapConnectionsWidget('buoyMap', Connections),
  };
};
